module.exports = __webpack_public_path__ + "assets/images/profiles/2020-2-desktop.jpg?v=c94e1d77";